<header [ngClass]="profileName" id="page-topbar">
  <div class="navbar-header px-0 d-flex flex-column">

    <div class="d-flex justify-content-between w-100 flex-row">
      <!-- LOGO -->
      <div class="navbar-brand-box px-18px">
        <a class="top-logo logo-light" routerLink="/">
          <span class="logo-sm btn-cursor">
            <!--  TODO logo change -->
            <img alt="" class="logo" src="/assets/img/samsungcare.svg" width="45px">
          </span>
        </a>
      </div>
      <!-- Notice Banner - Full Width -->
      <div style="width: 100%; margin-left: 50px; margin-top: 3px">
          <i class="fas fa-exclamation-triangle me-2"></i>
          <span class="font-weight-bold mb-2px">NOTICE: By 9/23, all users will need to request a new login on the
            <a (click)="handleGoToSlapPortal()" href="javascript:void(0)" class="btn btn-link p-0" style="color: #007bff; text-decoration: underline;">
              Samsung Care - SLAP B2B Visual Display Portal</a>, in order to create new service requests</span><br/>
        <span class="font-weight-bold mt-3px" style="margin-left: 82px">All existing data entries will be saved, and users will have “View-Only” access to their information for 90 days (12/15).</span>
      </div>
      <div class="dropdown pr-4px d-lg-none d-md-inline-block">
        <button (click)="dropDownToggle()" aria-controls="dropdown-basic"
                class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn" id="page-header-user-dropdown"
                type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>
      <!--  user info start    -->
      <div class="dropdown d-inline-block pr-20px d-none d-lg-flex justify-content-end top-lg" dropdown>
        <!-- Global Search Box -->
        <div class="d-flex align-items-center me-3">
          <div class="search-box d-flex align-items-center">
                        <a
                          href="https://www.samsungb2bsvc.com/assets/B2B_Portal-Request_Help_Pending_Dashboard_Use_Guide_Customer_6_2_25.pdf"
                          download
                          class="btn btn-link p-0 me-2 d-flex align-items-center justify-content-center"
                          title="Download Help Guide"
                          aria-label="Download Help Guide"
                          target="_blank"
                          style="color: inherit; background-color: transparent;"
                        >
<!--            <button class="btn text-start d-flex align-items-center"-->
<!--                    dropdownToggle-->
<!--                    (click)="getUserGuide()"-->
<!--                    type="button">-->
<!--              <span class="d-none d-sm-block user-item-desc">-->
                  <i class="fas fa-question-circle mr-8px" style="font-size: 18px;"></i>
<!--              </span>-->
<!--            </button>-->
                        </a>
            <div class="position-relative flex-grow-1">
              <input (keyup.enter)="globalSearch()" [(ngModel)]="searchText" class="form-control bg-light border-light"
                     placeholder="Search..." type="text">
              <i class="mdi mdi-magnify search-icon"></i>
            </div>
          </div>
        </div>


        <button aria-controls="dropdown-basic" class="btn header-item user text-start d-flex align-items-center"
                dropdownToggle
                type="button">
          <span class="d-none d-sm-block user-item-desc">
            <dp-avatar [displayType]="'circle'" [naming]="myInfo | displayName" [size]="34"></dp-avatar>
          </span>
        </button>
        <div *dropdownMenu class="dropdown-menu dropdown-menu-end pt-0" style="width: 216px;">
          <div class="p-3 bg-primary border-bottom">
            <h6 *ngIf="myInfo.firstName" class="mb-0 text-white">{{ myInfo | displayName }}</h6>
            <p class="mb-0 font-size-11 text-white-50 fw-semibold">{{ myInfo.username }}</p>
          </div>
          <a (click)="editUserInfo()" class="dropdown-item" href="javascript: void(0);">
            <i class="mdi mdi-account text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Profile</span>
          </a>
          <a (click)="registerMFA()" class="dropdown-item" href="javascript: void(0);">
            <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Register MFA</span>
          </a>
          <a (click)="logout($event)" class="dropdown-item" href="javascript: void(0);">
            <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
            <span class="align-middle">Logout</span>
          </a>
        </div>
      </div>
      <!--  user info end    -->
    </div>

  </div>



</header>

